import { ClientScoreHealthRangeProps } from '..';
import { ESTATE_STATUS_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { ESTATE_STATUS_SCORE_HEALTH_RANGE_BREAKPOINTS } from './constants';

export function ClientEstateStatusScoreHealthRange(
  props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>
) {
  return (
    <ClientScoreHealthRange
      {...props}
      element={ESTATE_STATUS_SCORECARD_ELEMENT_SYMBOL}
      breakpoints={ESTATE_STATUS_SCORE_HEALTH_RANGE_BREAKPOINTS}
    />
  );
}
